module.exports = __webpack_public_path__ + "images/notification.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/notification.png
// module id = fn2K
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13